import { useState, useEffect } from 'react';
import Modal from '../shared/Modal';
import { getTeams } from '../../utils/api';

export default function AddTeamLeadModal({ open, onClose, onSave, showToast }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('Team Lead');
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [saving, setSaving] = useState(false);
  const [availableTeams, setAvailableTeams] = useState([]);

  useEffect(() => {
    if (!open) return;
    getTeams()
      .then(data => setAvailableTeams((data || []).map(t => t.name).sort()))
      .catch(() => {});
  }, [open]);

  function toggleTeam(team) {
    setSelectedTeams(prev =>
      prev.includes(team) ? prev.filter(t => t !== team) : [...prev, team]
    );
  }

  function reset() {
    setName('');
    setEmail('');
    setRole('Team Lead');
    setSelectedTeams([]);
  }

  async function handleSave() {
    if (!name.trim() || !email.trim()) {
      showToast('Name and email are required.');
      return;
    }
    setSaving(true);
    const lead = {
      email: email.trim(),
      name: name.trim(),
      role,
      teams: selectedTeams.join(' | '),
      status: 'active',
    };
    try {
      await onSave(lead);
      reset();
      onClose();
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={() => { reset(); onClose(); }}
      title="Add Team Lead"
      footer={
        <>
          <button className="btn" onClick={() => { reset(); onClose(); }}>Cancel</button>
          <button className="btn btn-dark" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </>
      }
    >
      <div className="form-group">
        <label className="form-label">Name</label>
        <input className="form-input" value={name} onChange={e => setName(e.target.value)} placeholder="Full name" />
      </div>
      <div className="form-group">
        <label className="form-label">Google Account Email</label>
        <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Their Google email for login" />
      </div>
      <div className="form-group">
        <label className="form-label">Role</label>
        <select className="form-input" value={role} onChange={e => setRole(e.target.value)}>
          <option>Team Lead</option>
          <option>Admin</option>
        </select>
      </div>
      <div className="form-group">
        <label className="form-label">Teams{role === 'Admin' ? ' (Team Lead View)' : ''}</label>
        <div style={{ border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '8px 12px', maxHeight: 220, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 6 }}>
          {availableTeams.length === 0 ? (
            <div style={{ fontFamily: 'var(--font-b)', fontSize: 12, color: 'var(--muted)', fontWeight: 300 }}>Loading teams…</div>
          ) : availableTeams.map(t => (
            <label key={t} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontFamily: 'var(--font-h)', fontSize: 13, fontWeight: 700, color: 'var(--black)' }}>
              <input type="checkbox" checked={selectedTeams.includes(t)} onChange={() => toggleTeam(t)} style={{ accentColor: 'var(--black)' }} />
              {t}
            </label>
          ))}
        </div>
        {role === 'Admin' && (
          <div style={{ fontFamily: 'var(--font-b)', fontSize: 12, fontWeight: 300, color: 'var(--muted)', marginTop: 6 }}>
            Select which teams appear when this admin switches to Team Lead View.
          </div>
        )}
      </div>
    </Modal>
  );
}
